<form id="checkbox-group-form" [formGroup]="checkoutGroupForm">
  <div id="checkbox-group" class="checkbox-group">
    <div id="title-label" class="title">{{ checkboxGroup.label }}</div>
    <div id="description-label" class="description">{{ checkboxGroup.description }}</div>
    <div id="option-selection" class="checkbox-option-selection flex-col">
      <div *ngIf="!disableFormSelection" id="selection-instruction-label" class="selection-instructions flex-row">
        Check all that apply:
      </div>

      <div id="checkbox-option-form" class="checkbox-options flex-col" formArrayName="options">
        <div
          id="checkbox-option-{{ optionGroup.get('name')?.value }}"
          class="checkbox-option flex-col"
          *ngFor="let optionGroup of optionsFormArray.controls; let optionGroupIndex = index"
          [formGroupName]="optionGroupIndex"
        >
          <afp-checkbox id="afp-checkbox-{{ optionGroup.get('name')?.value }}" formControlName="checked">
            {{ optionGroup.get('label')?.value }}
          </afp-checkbox>

          <div
            id="additional-option-section-{{ optionGroup.get('name')?.value }}"
            class="additional-options flex-col"
            *ngIf="optionGroup.get('checked')?.value"
            formArrayName="additionalOptions"
          >
            <div
              id="additional-option-{{ additionalGroup.get('name')?.value }}"
              *ngFor="let additionalGroup of getAdditionalOptionsGroup(optionGroup); let additionalGroupIndex = index"
            >
              <div
                id="additional-option-container-{{ additionalGroup.get('name')?.value }}"
                *ngIf="additionalGroup.get('visible')?.value"
                [formGroupName]="additionalGroupIndex"
                class="additional-option-block"
              >
                <div id="additional-option-label" class="additional-option-label">{{ additionalGroup.get('label')?.value }}</div>

                <div id="additional-option-radio-group" *ngIf="additionalGroup.get('type')?.value === 'radio'" class="radio-group flex-">
                  <afp-radio-group orientation="vertical" formControlName="value">
                    <afp-radio
                      *ngFor="let opt of checkboxGroup.options[optionGroupIndex]?.additionalOptions?.[additionalGroupIndex]?.options"
                      [value]="opt.value"
                    >
                      {{ opt.label }}
                    </afp-radio>
                  </afp-radio-group>
                  <span
                    id="additional-option-radio-invalid-label"
                    class="invalid-form"
                    *ngIf="showValidationErrors && !additionalGroup.valid"
                  >
                    You must select at least one option.
                  </span>
                </div>
                <div
                  id="additional-option-checkbox-group"
                  *ngIf="additionalGroup.get('type')?.value === 'checkbox'"
                  [formGroupName]="'value'"
                  class="checkbox-group flex-row"
                >
                  <div
                    *ngFor="let opt of checkboxGroup.options[optionGroupIndex]?.additionalOptions?.[additionalGroupIndex]?.options"
                    class="additional-option"
                  >
                    <afp-checkbox id="afp-checkbox-{{ opt.value }}" [formControlName]="opt.value">{{ opt.label }}</afp-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span id="checkbox-group-invalid-label" class="invalid-form" *ngIf="showValidationErrors && !checkoutGroupForm.valid">
        You must select at least one option.
      </span>
    </div>
  </div>
</form>
